import { LuCheck } from 'react-icons/lu';
import { useUserContext } from '../../context/userContext';
import Sheet from '../../components/ui/sheet';
import { useTr } from '../../context/langContext';
import { ownerStrings } from '../../i18n/owner-strings';
import { webStrings } from '../../i18n/web-strings';

/** "Choose an outlet" — the Flutter `_pickOutlet` sheet on the owner dashboard. */
export default function OutletPicker({ open, onClose }: { open: boolean; onClose: () => void }) {
    const { outlets, outletId, selectOutlet } = useUserContext();
    const tr = useTr();

    return (
        <Sheet open={open} onClose={onClose} title={tr(ownerStrings, 'selectOutlet')}>
            <p className="mb-3 text-[12.5px] leading-relaxed text-ink3">
                {tr(webStrings, 'selectOutletBody')}
            </p>
            <div className="flex flex-col">
                {outlets.map((o) => (
                    <button
                        key={o.id}
                        onClick={() => {
                            selectOutlet(o.id);
                            onClose();
                        }}
                        className="flex items-center gap-3 rounded-xl px-3 py-3 text-left hover:bg-surf"
                    >
                        <div className="min-w-0 flex-1">
                            <p className="truncate text-sm font-semibold text-ink">{o.name}</p>
                            {o.city && <p className="truncate text-xs text-ink3">{o.city}</p>}
                        </div>
                        {o.id === outletId && <LuCheck size={17} className="text-owner-ink" />}
                    </button>
                ))}
            </div>
        </Sheet>
    );
}
